import { useState } from 'react';
import './Kontakt.css';

function Kontakt() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

 const API_URL = 'https://kehsefhrs.vercel.app/kontakt';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const res = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const data = await res.json();

      if (data.success) {
        setSubmitted(true);
        setFormData({ name: '', email: '', subject: '', message: '' });
        setTimeout(() => setSubmitted(false), 5000);
      } else {
        setError(data.error || 'Došlo je do greške prilikom slanja poruke.');
      }
    } catch (err) {
      console.error(err);
      setError('Greška pri povezivanju sa serverom. Molimo pokušajte ponovno.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="kontakt-container">
      <h1>Kontaktirajte nas</h1>
      
      <div className="kontakt-intro">
        <p>
          KEHSEF d.o.o. je tu da vam pomogne s vašim potrebama u području kibernetičke 
          sigurnosti i IT usluga. Naš tim stručnjaka spreman je odgovoriti na vaša pitanja 
          i pružiti vam personalizirana rješenja koja odgovaraju vašem poslovanju.
        </p>
        <p>
          Bilo da trebate savjetovanje, procjenu usklađenosti s EU regulativama ili 
          potpunu podršku u području informacijske sigurnosti, tu smo za vas.
        </p>
      </div>

      <div className="kontakt-content">
        <div className="kontakt-info">
          <h2>Naši podaci</h2>
          
          <div className="info-item">
            <h3>📍 Adresa</h3>
            <p>Zagreb, Hrvatska</p>
          </div>

          <div className="info-item">
            <h3>📧 Email</h3>
            <p>info@kehsef.hr</p>
          </div>

          <div className="info-item">
            <h3>🕐 Radno vrijeme</h3>
            <p>Ponedjeljak - Petak: 09:00 - 17:00</p>
          </div>
        </div>

        <div className="kontakt-form-container">
          <h2>Pošaljite nam poruku</h2>
          
          {submitted && (
            <div className="success-message">
              ✅ Hvala vam! Vaša poruka je uspješno poslana. 
              <br />
              Odgovorit ćemo vam u najkraćem mogućem roku.
            </div>
          )}

          {error && (
            <div className="error-message">
              ❌ {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="kontakt-form">
            <div className="form-group">
              <label htmlFor="name">Ime i prezime *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Vaše ime i prezime"
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email adresa *</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="vasa.email@example.com"
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="subject">Predmet</label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                placeholder="Tema vaše poruke"
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Poruka *</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="6"
                placeholder="Napišite vašu poruku ovdje..."
                disabled={loading}
              />
            </div>

            <button 
              type="submit" 
              className="submit-button"
              disabled={loading}
            >
              {loading ? 'Šalje se...' : 'Pošalji poruku'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Kontakt;